import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }


    sendConnectionRequestInvitation(userId: any, toUser: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/sendConnectionRequestInvitation?userId='
            + userId + '&toUser='
            + toUser, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    ignoreUserConnection(requestedUserId: any, toUserId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/ignoreUserConnection?requestedUserId=' + requestedUserId + '&toUserId=' + toUserId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    acceptUserConnection(userId: any, userConnectionId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/acceptUserConnection?userConnectionId=' + userConnectionId + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getUserConnections(userId: any, page: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserConnections?userId=' + userId + '&page=' + page, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getUserProfile(profileUserId: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserProfile?profileUserId=' + profileUserId + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }


    getMyCertificates(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Certificates/getUserCertificates?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    downloadCertificate(certId: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Certificates/downloadCertificate?userId=' + userId + '&certId=' + certId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }


    getUserConnectionList(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserConnectionList?userId=' + userId + '&page=1', {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getUserSentConnectionList(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserSentConnectionList?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getUserRequestedConnectionList(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserRequestedConnectionList?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    sendUserInvitation(userId: any, email: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/userInvitations?emailAddress=' + email + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    //

    //getUserConnectionYouMayKnow
    getUserConnectionYouMayKnow(userId: any, accountId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserConnectionYouMayKnow?userId=' + userId + '&accountId=' + accountId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    searchConnection(text: any, userAccountId: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/searchConnection?text=' + text + '&userAccountId=' + userAccountId + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }


    //updateMyProfile
    updateMyProfile(userData: any): any {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Profile/updateMyProfile', userData, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    changeMyPassword(userId: any, currentPassword: any, newPassword: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Account/ChangeMyPassword_m?userId='
            + userId + '&CurrentPassword='
            + currentPassword + '&NewPassword='
            + newPassword, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    changeProfilePicture(profilePicture: any, userId: any) {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Profile/changeProfilPicture?userId=' + userId
            , profilePicture, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    changeProfilCoverImage(coverPicture: any, userId: any) {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Profile/changeProfilCoverImage?userId=' + userId
            , coverPicture, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }


    getUserNotifications(userId: any, page: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUserNotifications?pageSize=1&page=' + page + '&userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getReachUsStaff(): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getReachUsStaff', {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    searchForUserByEmail(email:any ): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/searchForUserByEmail?email=' + email, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    activateDeactivateUser(isActive: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Account/ActivateDeactivateUser?userId=' + userId +'&isActive=' + isActive, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    setNotificationAsRead(item: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/setNotificationAsRead?notificationId=' + item.id, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    UnreadNotificationsCount: any = 0;
    getUnreadNotificationCount(userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Profile/getUnreadNotificationCount?userId=' + userId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    //

}
